export default __webpack_public_path__ + "static/media/react.10912b77.svg";